import React,{ Component } from 'react';
import SOCIAL from '../data/social';

class Socials extends Component {
    render(){
        return(
            <p>
                | {
                    SOCIAL.map(social => {
                        return(
                            // eslint-disable-next-line 
                            <span><a href={social.link} target="_blank" rel="noopener referer">{social.website}</a> | </span>
                        );
                    })
                }
            </p>
        )
    }
}

export default Socials;
